import styled from 'styled-components'

export const CardBrand = styled.img`
	margin: 0;
	padding: 0;
`
